import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { request } from '@trp-individual-investor-adv-disc/adv-shared';

export const getBreakPoints = (screenWidth, up = true) => {
  const theme = useTheme();
  if (up) {
    return useMediaQuery(theme.breakpoints.up(screenWidth));
  }
  return useMediaQuery(theme.breakpoints.down(screenWidth));
};

export const getMonthlyFee = (yearlyFee) => (Math.round((yearlyFee / 12) * 100) / 100).toFixed(2);

export const formatAgreementTypeName = (agrGroupByType) => {
  const { agreementTypeName, agreementTypeId, owners } = agrGroupByType;
  return `${agreementTypeName.toUpperCase()}${agreementTypeId === 26 && owners.length > 1 ? ' (JOINT)' : ''}`
};

export const getOwnersStringForAgreementGroupByType = agrGroupByType =>
  agrGroupByType.owners.reduce((agg, owner) => agg !== "" ? `${agg}, ${owner}` : agg + owner, "");

export const submitIP = (applicationConfig, link) => {
  const domain = window.location.href.split('/usis/advice/checkout')[0];
  const footerLink = `${domain}${link}`;
  if (process.env.REACT_APP_MOCK) {
    window.location.replace(footerLink);
  } else {
    request(
      applicationConfig,
      '/adv-disc-svc/service/investment-proposal/v1/activate',
      'post',
      {},
      null,
      '/usis/advice/checkout'
    )
      .then(() => {
        window.location.replace(footerLink);
      })
  }
};
